export const translations = {
  en: {
    brand: { name: "AstroFriend", tagline: "Your cosmic palm companion" },
    nav: {
      how: "How it works",
      pricing: "Pricing",
      readings: "My Readings",
      login: "Login",
      logout: "Logout",
      readPalm: "Read My Palm",
      library: "Q&A Library",
    },
    home: {
      eyebrow: "AI Palmistry • Hast Rekha",
      title: "Read Your Destiny in the Palm of Your Hand",
      subtitle:
        "AstroFriend blends ancient palmistry with modern AI to reveal the story written across your life, heart, head and fate lines.",
      cta: "Read My Palm",
      secondary: "How it works",
      trust: "Private & secure • Instant reading • Hindi & English",
      featuresTitle: "The wisdom in your hands",
      features: [
        { t: "Snap your palm", d: "Upload a clear photo of your palm — our AI checks the quality instantly." },
        { t: "AI decodes the lines", d: "Life, heart, head, fate lines and mounts analysed with mystical care." },
        { t: "Past • Present • Future", d: "Beautiful, colourful readings you can save and download as a PDF." },
      ],
      stepsTitle: "Three simple steps",
      steps: [
        { t: "Position your hand", d: "Follow our lighting & angle guide for the clearest read." },
        { t: "AI quality check", d: "We make sure your photo is sharp before reading." },
        { t: "Get your reading", d: "Detailed, uplifting insights across time." },
      ],
    },
    instructions: {
      title: "How to photograph your palm",
      subtitle: "A clear photo means a clearer reading. Follow these simple steps.",
      goodTitle: "A perfect palm photo",
      steps: [
        { t: "Use your dominant hand", d: "Right hand for most people. Keep fingers relaxed and slightly apart." },
        { t: "Bright, even light", d: "Face a window or soft light. Avoid harsh shadows and glare." },
        { t: "Hold steady & straight", d: "Keep the camera parallel to your palm, fill the frame with your hand." },
        { t: "Focus on the lines", d: "Make sure the major lines are sharp and clearly visible." },
      ],
      dos: ["Bright natural light", "Whole palm in frame", "Sharp, in focus", "Flat, open hand"],
      donts: ["Blurry or dark", "Cropped fingers", "Strong shadows", "Tilted angle"],
      cta: "I'm ready — Upload my palm",
    },
    upload: {
      profileTitle: "Tell us a little about you",
      profileSub: "Your palm reading will address you by name. Your details stay private.",
      yourName: "Your name",
      namePh: "e.g. Raman",
      yourMobile: "Mobile number",
      continueBtn: "Continue to palm reading",
      privacyNote: "We use your name to personalise the reading and your number only for report support. Never shared.",
      profileSaved: "Saved! Now upload your palm photo.",
      edit: "Edit",
      existingTitle: "Your palm reading is already ready",
      existingSub: "Palm lines do not change quickly — your saved reading stays the same. Open it, or request a fresh reading.",
      viewExisting: "View my reading",
      freshReading: "New fresh reading",
      title: "Upload your palm photo",
      subtitle: "We'll check the image quality before reading.",
      choose: "Add your palm photo",
      change: "Choose another photo",
      sourceHint: "Take a clear photo of your dominant hand's palm in good light, or pick one from your gallery.",
      takePhoto: "Take a photo",
      loadingPhoto: "Loading your photo…",
      photoReadError: "Could not read this photo. Please try again or choose a JPG/PNG from your gallery.",
      takePhotoSub: "Open camera",
      fromGallery: "Upload from gallery",
      fromGallerySub: "JPG / PNG",
      checking: "Checking image quality…",
      reading: "Reading your palm…",
      readingSub: "Consulting the stars and your lines. This takes about 2 minutes.",
      steps: [
        "Checking your palm photo…",
        "Reading Life, Heart, Head & Fate lines…",
        "Studying the mounts…",
        "Looking into your career & work…",
        "Reading wealth & finance signs…",
        "Seeing love & marriage indications…",
        "Reading health & family bonds…",
        "Checking home & property yog…",
        "Weaving your Past · Present · Future…",
        "Finding your lucky charms & mantra…",
        "Pandit ji is finalizing your report…",
      ],
      stepDone: "Done",
      qualityGood: "Great photo! Ready to read.",
      qualityBad: "This photo needs a retake.",
      notPalm: "We couldn't detect a palm. Please upload a clear palm photo.",
      brightness: "Brightness",
      sharpness: "Sharpness",
      alignment: "Alignment",
      retake: "Retake",
      readNow: "Read my palm",
      useAnyway: "Read anyway",
    },
    result: {
      title: "Your Palm Reading",
      greeting: "Namaste {name} ji 🙏",
      overview: "Overview",
      lines: "Palm Lines",
      timeline: "Your Timeline",
      past: "Past",
      present: "Present",
      future: "Future",
      mounts: "The Mounts",
      lucky: "Lucky Charms",
      luckyNumber: "Number",
      luckyColor: "Colour",
      luckyDay: "Day",
      luckyGem: "Gemstone",
      luckyMantra: "Mantra",
      lifeAreas: "Your Life Areas",
      lifeAreasSub: "What your palm says about the things that matter most",
      locked: "Unlock your full reading",
      lockedSub: "Get the complete analysis of all lines, career, wealth, love, health, family & property insights, your full timeline and a beautiful PDF report.",
      unlock: "Unlock full report",
      downloadPdf: "Download PDF",
      newReading: "New reading",
      preparing: "Preparing your PDF…",
      emailSent: "Your colorful report has been emailed to you! ✦",
      emailing: "Emailing your report…",
      emailFailed: "Could not email the report. Tap 'Email PDF' to retry.",
      emailPdf: "Email PDF report",
      whatsappReport: "Send report on WhatsApp",
      whatsappHint: "Get the PDF link on your WhatsApp ({mobile}) — tap and just press Send.",
      waFailed: "Could not prepare the WhatsApp link. Please try again.",
      shareTitle: "Share AstroFriend with friends",
      shareText: "I just got my palm read by AI on AstroFriend — so insightful! Read your palm too ✦",
      copyLink: "Copy link",
      moreShare: "Instagram & more",
      shareCopiedHint: "Text & link copied — paste it in Instagram or any app",
      pdfReady: "Your PDF is ready",
      audioTitle: "Listen to your reading",
      audioSub: "Your reading as an audio file in {lang} — listen online or download MP3.",
      audioPreviewNote: "Free preview: overview audio only. Unlock the full report for the complete audio.",
      audioGenerate: "Create audio ({lang})",
      audioGenerating: "Creating your audio… this takes 1-2 minutes",
      audioDownload: "Download MP3",
      audioFailed: "Audio could not be created. Please try again.",
      audioLangHi: "Hindi",
      audioLangEn: "English",
      preparingShare: "Preparing your report…",
      linkCopied: "Link copied!",
    },
    pricing: {
      title: "Choose your reading",
      subtitle: "Start free. Unlock the full celestial report whenever you're ready.",
      free: "Basic Preview",
      freePrice: "Free",
      paid: "Full Celestial Reading",
      popular: "Most popular",
      freeFeatures: ["Overview summary", "Life line insight", "Lucky number & colour"],
      paidFeatures: [
        "Everything in Basic",
        "Heart, Head & Fate lines",
        "The Mounts analysis",
        "Full Past • Present • Future",
        "Downloadable PDF report",
        "Saved to your history",
      ],
      freeCta: "Start free reading",
      paidCta: "Get full reading",
      note: "One-time payment per reading. No subscription.",
      couponHint: "Coupon codes available at checkout",
    },
    payment: {
      title: "Unlock full report",
      desc: "Complete palmistry analysis + PDF download.",
      pay: "Pay",
      mockNote: "Demo mode — no real charge. Add Razorpay keys to go live.",
      processing: "Processing payment…",
      success: "Unlocked! Enjoy your full reading.",
      cancel: "Maybe later",
      refundNote: "Payments are non-refundable once completed.",
      couponLabel: "Have a coupon code?",
      couponPlaceholder: "Enter coupon code",
      apply: "Apply",
      remove: "Remove",
      couponApplied: "Coupon applied",
      invalidCoupon: "Invalid coupon code",
      couponUsedByYou: "You have already used this coupon.",
      off: "OFF",
      freeUnlock: "Unlock for free",
      youSave: "You save",
    },
    receipt: {
      success: "Payment Successful",
      thankYou: "Thank you! Your full report is unlocked.",
      receiptNo: "Receipt No.",
      date: "Date",
      item: "Item",
      customer: "Customer",
      base: "Base price",
      discount: "Discount",
      paid: "Amount paid",
      paymentId: "Payment ID",
      viewReport: "View my report",
      download: "Download receipt",
      freeLine: "Unlocked free with coupon",
    },
    admin: {
      usersTitle: "Users (CRM)",
      maintTitle: "Maintenance Mode",
      maintSub: "When ON, all visitors see a maintenance page and every feature is paused. Admins can still use the site.",
      maintMsgHi: "Message (Hindi)",
      maintMsgEn: "Message (English)",
      maintOn: "Maintenance mode is ON — site is paused for visitors",
      maintOff: "Maintenance mode is OFF — site is live",
      maintSaved: "Messages saved",
      maintWarning: "⚠ Site is currently in maintenance — visitors cannot use any feature.",
      exportUsers: "Export Users CSV",
      readingsTitle: "Readings",
      freeUnlock: "Free unlock",
      resendPdf: "Resend PDF",
      unlockedBadge: "Unlocked",
      lockedBadge: "Locked",
      pdfStored: "PDF stored",
      noPdf: "No PDF yet",
      unlockDone: "Reading unlocked for free — receipt emailed to user",
      resentPdf: "PDF report re-sent to user's email",
      resentLink: "Report link emailed — PDF will auto-send when the user opens it",
      confirmUnlock: "Unlock this reading for free?",
      mobile: "Mobile",
      searchUsers: "Search by email or name…",
      registered: "Registered",
      readingsCol: "Readings",
      paymentsCol: "Payments",
      spentCol: "Spent",
      noPayments: "No payments yet",
      noUsers: "No users found",
      title: "Coupon Admin",
      subtitle: "Create, enable or disable discount coupons.",
      code: "Coupon code",
      percent: "Discount %",
      active: "Active",
      inactive: "Inactive",
      add: "Add coupon",
      save: "Save",
      delete: "Delete",
      enable: "Enable",
      disable: "Disable",
      status: "Status",
      actions: "Actions",
      created: "Coupon created",
      updated: "Coupon updated",
      deleted: "Coupon deleted",
      exists: "Coupon already exists",
      empty: "No coupons yet. Add one above.",
      confirmDelete: "Delete this coupon?",
      accessDenied: "Admin access only.",
      expiry: "Expiry date",
      maxUses: "Max uses",
      unlimited: "Unlimited",
      noExpiry: "No expiry",
      used: "Used",
      couponsTitle: "Manage coupons",
      statsTitle: "Sales dashboard",
      revenue: "Revenue",
      payments: "Paid orders",
      freeUnlocks: "Free unlocks",
      unlocked: "Readings unlocked",
      couponUsage: "Coupon usage",
      redeemed: "Redeemed",
      discountGiven: "Discount given",
      expired: "Expired",
      exportPayments: "Export payments CSV",
      exportCoupons: "Export coupon usage CSV",
    },
    profile: {
      title: "My Readings",
      subtitle: "Your saved palm readings.",
      empty: "No readings yet. Let's read your first palm!",
      readNow: "Read my palm",
      view: "View reading",
      unlocked: "Full report",
      preview: "Preview",
    },
    login: {
      title: "Welcome to AstroFriend",
      subtitle: "Sign in to read your palm and save your readings.",
      google: "Continue with Google",
      privacy: "We only use your account to save your readings.",
    },
    footer: {
      about: "About AstroFriend",
      aboutText:
        "AstroFriend is an AI-powered palmistry companion created for entertainment and self-reflection. We combine timeless hast-rekha traditions with modern AI.",
      disclaimerTitle: "Disclaimer",
      disclaimer:
        "AstroFriend is for entertainment purposes only. Readings are AI-generated interpretations and are not a substitute for professional medical, legal, financial or psychological advice.",
      links: "Explore",
      refund: "Return & Refund Policy",
      policies: "Company & Policies",
      contact: "Contact Us",
      aboutUs: "About Us",
      services: "Services & Pricing",
      privacy: "Privacy Policy",
      cancellation: "Cancellation Policy",
      shipping: "Shipping & Delivery",
      rights: "All rights reserved.",
    },
    testimonials: {
      title: "What our seekers say",
      subtitle: "Loved by thousands exploring astrology & palmistry with AstroFriend.",
      demoLabel: "Sample / demo reviews shown for showcase — not genuine customer testimonials.",
    },
    refund: {
      title: "Return & Refund Policy",
      intro: "Please read our refund policy carefully before making a payment.",
      body: "All payments are non-refundable once completed. A refund is only possible if a technical issue on our website prevented the palmistry report from being generated — this will be reviewed by our team.",
      note: "Approved refunds are processed through the original payment method. By completing a payment on AstroFriend you acknowledge and accept this Return & Refund Policy. Reports are digital and are usually delivered instantly after payment.",
    },
    common: { loading: "Loading…", back: "Back", tryAgain: "Try again" },
    library: {
      title: "Astrology & Palmistry Q&A Library",
      subtitle: "Find quick, easy answers to your astrology and palmistry questions.",
      searchPlaceholder: "Search your question...",
      categoriesTitle: "Browse by category",
      allQuestions: "All questions",
      noResults: "No questions found. Try another keyword.",
      clearCategory: "Clear",
      questions: "questions",
      filters: {
        all: "All", astrology: "Astrology", kundli: "Kundli", palmistry: "Palmistry",
        career: "Career", marriage: "Marriage", business: "Business", finance: "Finance",
        education: "Education", foreign: "Foreign Travel", family: "Family",
        property: "Property", forecast: "Forecast",
      },
    },
    detail: {
      back: "Back to Library",
      shortAnswer: "Short Answer",
      detailed: "Detailed Explanation",
      traditional: "Traditional Interpretation",
      relatedTopics: "Related Topics",
      keywords: "Keywords",
      relatedQuestions: "Related Questions",
      askKundli: "Ask My Kundli AI",
      askPalmistry: "Ask AI Palmistry",
      disclaimer: "Astrology and palmistry readings are traditional or cultural interpretations for guidance and entertainment — they are not guaranteed predictions.",
      healthDisclaimer: "For any health concern, please consult a qualified healthcare professional. This answer is not medical advice.",
    },
    ask: {
      kundliTitle: "Ask My Kundli AI",
      kundliDesc: "Get a personalised astrological perspective on this question.",
      palmistryTitle: "Ask AI Palmistry",
      palmistryDesc: "Upload your palm photo for a traditional interpretation of this question.",
      name: "Your name (optional)",
      dob: "Date of birth",
      tob: "Time of birth (optional)",
      place: "Place of birth",
      yourQuestion: "Your question",
      generate: "Get answer",
      generating: "Consulting the stars…",
      readingPalm: "Reading your palm…",
      choosePhoto: "Choose palm photo",
      changePhoto: "Change photo",
      answerTitle: "AstroFriend says",
      loginRequired: "Please log in to use AI features.",
      askAgain: "Ask another",
      close: "Close",
      disclaimer: "Traditional interpretation for guidance only — not a guaranteed prediction.",
    },
  },

  hi: {
    brand: { name: "AstroFriend", tagline: "आपका ब्रह्मांडीय हस्तरेखा साथी" },
    nav: {
      how: "कैसे काम करता है",
      pricing: "मूल्य",
      readings: "मेरी रीडिंग",
      login: "लॉगिन",
      logout: "लॉगआउट",
      readPalm: "मेरी हथेली पढ़ें",
      library: "प्रश्नोत्तर",
    },
    home: {
      eyebrow: "AI हस्तरेखा शास्त्र",
      title: "अपनी हथेली में छिपा भाग्य जानिए",
      subtitle:
        "AstroFriend प्राचीन हस्तरेखा विज्ञान को आधुनिक AI से जोड़कर आपकी जीवन, हृदय, मस्तिष्क और भाग्य रेखा की कहानी बताता है।",
      cta: "मेरी हथेली पढ़ें",
      secondary: "कैसे काम करता है",
      trust: "निजी और सुरक्षित • तुरंत रीडिंग • हिंदी और अंग्रेज़ी",
      featuresTitle: "आपके हाथों में छिपा ज्ञान",
      features: [
        { t: "हथेली की फोटो लें", d: "अपनी हथेली की साफ़ फोटो अपलोड करें — हमारा AI तुरंत गुणवत्ता जाँचता है।" },
        { t: "AI रेखाएँ पढ़ता है", d: "जीवन, हृदय, मस्तिष्क, भाग्य रेखाएँ और पर्वतों का सूक्ष्म विश्लेषण।" },
        { t: "भूत • वर्तमान • भविष्य", d: "सुंदर, रंगीन रीडिंग जिसे आप सेव और PDF में डाउनलोड कर सकते हैं।" },
      ],
      stepsTitle: "तीन आसान कदम",
      steps: [
        { t: "हाथ की स्थिति", d: "सबसे साफ़ रीडिंग के लिए हमारी रोशनी और कोण गाइड अपनाएँ।" },
        { t: "AI गुणवत्ता जाँच", d: "पढ़ने से पहले हम फोटो की स्पष्टता सुनिश्चित करते हैं।" },
        { t: "अपनी रीडिंग पाएँ", d: "समय के पार विस्तृत, उत्साहवर्धक अंतर्दृष्टि।" },
      ],
    },
    instructions: {
      title: "अपनी हथेली की फोटो कैसे लें",
      subtitle: "साफ़ फोटो का मतलब है बेहतर रीडिंग। इन आसान कदमों का पालन करें।",
      goodTitle: "एक आदर्श हथेली फोटो",
      steps: [
        { t: "अपना प्रमुख हाथ प्रयोग करें", d: "अधिकतर लोगों के लिए दायाँ हाथ। उँगलियाँ ढीली और थोड़ी अलग रखें।" },
        { t: "उज्ज्वल, समान रोशनी", d: "खिड़की या मुलायम रोशनी की ओर मुख करें। तेज़ छाया और चमक से बचें।" },
        { t: "स्थिर और सीधा पकड़ें", d: "कैमरा हथेली के समानांतर रखें, फ्रेम को हाथ से भरें।" },
        { t: "रेखाओं पर फोकस", d: "सुनिश्चित करें कि मुख्य रेखाएँ तेज़ और स्पष्ट दिखें।" },
      ],
      dos: ["उज्ज्वल प्राकृतिक रोशनी", "पूरी हथेली फ्रेम में", "तेज़, फोकस में", "समतल, खुला हाथ"],
      donts: ["धुँधली या अँधेरी", "कटी हुई उँगलियाँ", "गहरी छाया", "तिरछा कोण"],
      cta: "मैं तैयार हूँ — हथेली अपलोड करें",
    },
    upload: {
      profileTitle: "अपने बारे में थोड़ा बताएँ",
      profileSub: "आपकी हस्तरेखा रीडिंग आपको नाम से संबोधित करेगी। आपकी जानकारी गोपनीय रहती है।",
      yourName: "आपका नाम",
      namePh: "जैसे: रमन",
      yourMobile: "मोबाइल नंबर",
      continueBtn: "हस्तरेखा पढ़ने के लिए आगे बढ़ें",
      privacyNote: "नाम का उपयोग रीडिंग को व्यक्तिगत बनाने के लिए और नंबर केवल रिपोर्ट सहायता के लिए। कभी साझा नहीं किया जाता।",
      profileSaved: "सहेज लिया! अब अपनी हथेली की फोटो अपलोड करें।",
      edit: "बदलें",
      existingTitle: "आपकी हस्तरेखा रीडिंग पहले से तैयार है",
      existingSub: "हथेली की रेखाएँ जल्दी नहीं बदलतीं — आपकी सहेजी हुई रीडिंग वही रहती है। उसे देखें, या नई रीडिंग बनवाएँ।",
      viewExisting: "मेरी रीडिंग देखें",
      freshReading: "नई ताज़ा रीडिंग",
      title: "अपनी हथेली की फोटो अपलोड करें",
      subtitle: "पढ़ने से पहले हम फोटो की गुणवत्ता जाँचेंगे।",
      choose: "अपनी हथेली की फोटो जोड़ें",
      change: "दूसरी फोटो चुनें",
      sourceHint: "अच्छी रोशनी में अपने प्रमुख हाथ की हथेली की साफ़ फोटो लें, या गैलरी से चुनें।",
      takePhoto: "फोटो खींचें",
      loadingPhoto: "आपकी फोटो लोड हो रही है…",
      photoReadError: "यह फोटो पढ़ी नहीं जा सकी। कृपया दोबारा लें या गैलरी से JPG/PNG चुनें।",
      takePhotoSub: "कैमरा खोलें",
      fromGallery: "गैलरी से अपलोड करें",
      fromGallerySub: "JPG / PNG",
      checking: "फोटो की गुणवत्ता जाँच रहे हैं…",
      reading: "आपकी हथेली पढ़ रहे हैं…",
      readingSub: "सितारों और आपकी रेखाओं से परामर्श। इसमें लगभग 2 मिनट लगते हैं।",
      steps: [
        "हथेली की फोटो जाँची जा रही है…",
        "जीवन, हृदय, मस्तिष्क और भाग्य रेखाएँ पढ़ी जा रही हैं…",
        "पर्वतों का अध्ययन हो रहा है…",
        "करियर और नौकरी देखा जा रहा है…",
        "धन और आर्थिक संकेत पढ़े जा रहे हैं…",
        "प्रेम और विवाह के योग देखे जा रहे हैं…",
        "स्वास्थ्य और परिवार के बंधन पढ़े जा रहे हैं…",
        "घर और संपत्ति का योग जाँचा जा रहा है…",
        "भूत · वर्तमान · भविष्य की समयरेखा बन रही है…",
        "शुभ अंक, रत्न और मंत्र खोजे जा रहे हैं…",
        "पंडित जी आपकी रिपोर्ट को अंतिम रूप दे रहे हैं…",
      ],
      stepDone: "हो गया",
      qualityGood: "बढ़िया फोटो! पढ़ने के लिए तैयार।",
      qualityBad: "इस फोटो को दोबारा लेना होगा।",
      notPalm: "हमें हथेली नहीं मिली। कृपया साफ़ हथेली की फोटो अपलोड करें।",
      brightness: "चमक",
      sharpness: "स्पष्टता",
      alignment: "संरेखण",
      retake: "दोबारा लें",
      readNow: "मेरी हथेली पढ़ें",
      useAnyway: "फिर भी पढ़ें",
    },
    result: {
      title: "आपकी हस्तरेखा रीडिंग",
      greeting: "नमस्ते {name} जी 🙏",
      overview: "सारांश",
      lines: "हथेली की रेखाएँ",
      timeline: "आपकी समयरेखा",
      past: "भूतकाल",
      present: "वर्तमान",
      future: "भविष्य",
      mounts: "पर्वत",
      lucky: "शुभ संकेत",
      luckyNumber: "अंक",
      luckyColor: "रंग",
      luckyDay: "दिन",
      luckyGem: "रत्न",
      luckyMantra: "मंत्र",
      lifeAreas: "आपके जीवन के क्षेत्र",
      lifeAreasSub: "आपकी हथेली उन बातों के बारे में क्या कहती है जो सबसे ज़्यादा मायने रखती हैं",
      locked: "अपनी पूरी रीडिंग अनलॉक करें",
      lockedSub: "सभी रेखाओं का पूरा विश्लेषण, करियर, धन, प्रेम, स्वास्थ्य, परिवार और संपत्ति की भविष्यवाणियाँ, पूरी समयरेखा और एक सुंदर PDF रिपोर्ट पाएँ।",
      unlock: "पूरी रिपोर्ट अनलॉक करें",
      downloadPdf: "PDF डाउनलोड करें",
      newReading: "नई रीडिंग",
      preparing: "आपकी PDF तैयार हो रही है…",
      emailSent: "आपकी रंगीन रिपोर्ट आपकी ईमेल पर भेज दी गई है! ✦",
      emailing: "आपकी रिपोर्ट ईमेल की जा रही है…",
      emailFailed: "रिपोर्ट ईमेल नहीं हो सकी। 'PDF ईमेल करें' पर टैप करके फिर कोशिश करें।",
      emailPdf: "PDF ईमेल करें",
      whatsappReport: "WhatsApp पर रिपोर्ट भेजें",
      whatsappHint: "PDF लिंक अपने WhatsApp ({mobile}) पर पाएँ — टैप करें और बस Send दबाएँ।",
      waFailed: "WhatsApp लिंक तैयार नहीं हो सका। कृपया फिर कोशिश करें।",
      shareTitle: "AstroFriend को दोस्तों के साथ साझा करें",
      shareText: "मैंने AstroFriend पर AI से अपनी हस्तरेखा पढ़वाई — बहुत सटीक! आप भी अपनी हथेली पढ़वाएँ ✦",
      copyLink: "लिंक कॉपी करें",
      moreShare: "Instagram और अन्य",
      shareCopiedHint: "टेक्स्ट और लिंक कॉपी हो गया — Instagram या किसी भी app में paste करें",
      pdfReady: "आपकी PDF तैयार है",
      audioTitle: "अपनी रीडिंग सुनें",
      audioSub: "आपकी रीडिंग {lang} में ऑडियो फ़ाइल के रूप में — ऑनलाइन सुनें या MP3 डाउनलोड करें।",
      audioPreviewNote: "फ्री प्रीव्यू: केवल सारांश का ऑडियो। पूरे ऑडियो के लिए पूरी रिपोर्ट अनलॉक करें।",
      audioGenerate: "ऑडियो बनाएँ ({lang})",
      audioGenerating: "आपका ऑडियो बन रहा है… इसमें 1-2 मिनट लगते हैं",
      audioDownload: "MP3 डाउनलोड करें",
      audioFailed: "ऑडियो नहीं बन सका। कृपया फिर कोशिश करें।",
      audioLangHi: "हिंदी",
      audioLangEn: "English",
      preparingShare: "आपकी रिपोर्ट तैयार हो रही है…",
      linkCopied: "लिंक कॉपी हो गया!",
    },
    pricing: {
      title: "अपनी रीडिंग चुनें",
      subtitle: "मुफ़्त शुरू करें। तैयार होने पर पूरी दिव्य रिपोर्ट अनलॉक करें।",
      free: "बेसिक झलक",
      freePrice: "मुफ़्त",
      paid: "पूर्ण दिव्य रीडिंग",
      popular: "सबसे लोकप्रिय",
      freeFeatures: ["सारांश", "जीवन रेखा अंतर्दृष्टि", "शुभ अंक और रंग"],
      paidFeatures: [
        "बेसिक की सभी सुविधाएँ",
        "हृदय, मस्तिष्क और भाग्य रेखा",
        "पर्वतों का विश्लेषण",
        "पूरा भूत • वर्तमान • भविष्य",
        "डाउनलोड करने योग्य PDF रिपोर्ट",
        "आपके इतिहास में सेव",
      ],
      freeCta: "मुफ़्त रीडिंग शुरू करें",
      paidCta: "पूरी रीडिंग पाएँ",
      note: "प्रति रीडिंग एक बार भुगतान। कोई सदस्यता नहीं।",
      couponHint: "चेकआउट पर कूपन कोड उपलब्ध हैं",
    },
    payment: {
      title: "पूरी रिपोर्ट अनलॉक करें",
      desc: "पूर्ण हस्तरेखा विश्लेषण + PDF डाउनलोड।",
      pay: "भुगतान करें",
      mockNote: "डेमो मोड — कोई वास्तविक शुल्क नहीं। लाइव जाने के लिए Razorpay कुंजियाँ जोड़ें।",
      processing: "भुगतान संसाधित हो रहा है…",
      success: "अनलॉक हो गया! अपनी पूरी रीडिंग का आनंद लें।",
      cancel: "बाद में",
      refundNote: "भुगतान पूरा होने के बाद वापसी नहीं होती।",
      couponLabel: "कूपन कोड है?",
      couponPlaceholder: "कूपन कोड दर्ज करें",
      apply: "लगाएँ",
      remove: "हटाएँ",
      couponApplied: "कूपन लागू हुआ",
      invalidCoupon: "अमान्य कूपन कोड",
      couponUsedByYou: "आप यह कूपन पहले ही उपयोग कर चुके हैं।",
      off: "छूट",
      freeUnlock: "मुफ़्त अनलॉक करें",
      youSave: "आपकी बचत",
    },
    receipt: {
      success: "भुगतान सफल",
      thankYou: "धन्यवाद! आपकी पूरी रिपोर्ट अनलॉक हो गई है।",
      receiptNo: "रसीद संख्या",
      date: "दिनांक",
      item: "मद",
      customer: "ग्राहक",
      base: "मूल कीमत",
      discount: "छूट",
      paid: "भुगतान राशि",
      paymentId: "भुगतान ID",
      viewReport: "मेरी रिपोर्ट देखें",
      download: "रसीद डाउनलोड करें",
      freeLine: "कूपन से मुफ़्त अनलॉक",
    },
    admin: {
      usersTitle: "उपयोगकर्ता (CRM)",
      maintTitle: "रखरखाव मोड (Maintenance)",
      maintSub: "ON होने पर सभी visitors को maintenance पेज दिखेगा और सभी features रुक जाएँगे। Admin साइट इस्तेमाल कर सकेंगे।",
      maintMsgHi: "संदेश (हिंदी)",
      maintMsgEn: "संदेश (English)",
      maintOn: "Maintenance मोड ON — visitors के लिए साइट रुकी हुई है",
      maintOff: "Maintenance मोड OFF — साइट live है",
      maintSaved: "संदेश सहेजे गए",
      maintWarning: "⚠ साइट अभी maintenance में है — visitors कोई feature इस्तेमाल नहीं कर सकते।",
      exportUsers: "यूज़र्स CSV निर्यात",
      readingsTitle: "रीडिंग्स",
      freeUnlock: "फ्री अनलॉक",
      resendPdf: "PDF दोबारा भेजें",
      unlockedBadge: "अनलॉक",
      lockedBadge: "लॉक",
      pdfStored: "PDF सहेजी है",
      noPdf: "PDF अभी नहीं",
      unlockDone: "रीडिंग फ्री अनलॉक हो गई — user को रसीद ईमेल भेजी गई",
      resentPdf: "PDF रिपोर्ट user के ईमेल पर दोबारा भेज दी गई",
      resentLink: "रिपोर्ट लिंक ईमेल किया — user खोलेगा तो PDF अपने-आप जाएगी",
      confirmUnlock: "यह रीडिंग फ्री अनलॉक करें?",
      mobile: "मोबाइल",
      searchUsers: "ईमेल या नाम से खोजें…",
      registered: "पंजीकरण",
      readingsCol: "रीडिंग",
      paymentsCol: "भुगतान",
      spentCol: "खर्च",
      noPayments: "अभी कोई भुगतान नहीं",
      noUsers: "कोई उपयोगकर्ता नहीं मिला",
      title: "कूपन एडमिन",
      subtitle: "डिस्काउंट कूपन बनाएँ, चालू या बंद करें।",
      code: "कूपन कोड",
      percent: "छूट %",
      active: "सक्रिय",
      inactive: "निष्क्रिय",
      add: "कूपन जोड़ें",
      save: "सहेजें",
      delete: "हटाएँ",
      enable: "चालू करें",
      disable: "बंद करें",
      status: "स्थिति",
      actions: "क्रियाएँ",
      created: "कूपन बनाया गया",
      updated: "कूपन अपडेट हुआ",
      deleted: "कूपन हटाया गया",
      exists: "कूपन पहले से मौजूद है",
      empty: "अभी कोई कूपन नहीं। ऊपर से जोड़ें।",
      confirmDelete: "यह कूपन हटाएँ?",
      accessDenied: "केवल एडमिन के लिए।",
      expiry: "समाप्ति तिथि",
      maxUses: "अधिकतम उपयोग",
      unlimited: "असीमित",
      noExpiry: "कोई समाप्ति नहीं",
      used: "उपयोग",
      couponsTitle: "कूपन प्रबंधन",
      statsTitle: "बिक्री डैशबोर्ड",
      revenue: "राजस्व",
      payments: "भुगतान ऑर्डर",
      freeUnlocks: "मुफ़्त अनलॉक",
      unlocked: "अनलॉक रीडिंग",
      couponUsage: "कूपन उपयोग",
      redeemed: "रिडीम",
      discountGiven: "दी गई छूट",
      expired: "समाप्त",
      exportPayments: "भुगतान CSV निर्यात",
      exportCoupons: "कूपन उपयोग CSV निर्यात",
    },
    profile: {
      title: "मेरी रीडिंग",
      subtitle: "आपकी सेव की गई हस्तरेखा रीडिंग।",
      empty: "अभी तक कोई रीडिंग नहीं। चलिए आपकी पहली हथेली पढ़ते हैं!",
      readNow: "मेरी हथेली पढ़ें",
      view: "रीडिंग देखें",
      unlocked: "पूरी रिपोर्ट",
      preview: "झलक",
    },
    login: {
      title: "AstroFriend में आपका स्वागत है",
      subtitle: "अपनी हथेली पढ़ने और रीडिंग सेव करने के लिए साइन इन करें।",
      google: "Google से जारी रखें",
      privacy: "हम आपके खाते का उपयोग केवल आपकी रीडिंग सेव करने के लिए करते हैं।",
    },
    footer: {
      about: "AstroFriend के बारे में",
      aboutText:
        "AstroFriend एक AI-संचालित हस्तरेखा साथी है, जिसे मनोरंजन और आत्म-चिंतन के लिए बनाया गया है। हम प्राचीन हस्तरेखा परंपराओं को आधुनिक AI से जोड़ते हैं।",
      disclaimerTitle: "अस्वीकरण",
      disclaimer:
        "AstroFriend केवल मनोरंजन के उद्देश्य से है। रीडिंग AI-जनित व्याख्याएँ हैं और यह पेशेवर चिकित्सा, कानूनी, वित्तीय या मनोवैज्ञानिक सलाह का विकल्प नहीं हैं।",
      links: "एक्सप्लोर करें",
      refund: "रिटर्न और रिफंड नीति",
      policies: "कंपनी और नीतियाँ",
      contact: "संपर्क करें",
      aboutUs: "हमारे बारे में",
      services: "सेवाएँ और मूल्य",
      privacy: "गोपनीयता नीति",
      cancellation: "रद्दीकरण नीति",
      shipping: "शिपिंग और डिलीवरी",
      rights: "सर्वाधिकार सुरक्षित।",
    },
    testimonials: {
      title: "हमारे उपयोगकर्ता क्या कहते हैं",
      subtitle: "हज़ारों लोग AstroFriend के साथ ज्योतिष और हस्तरेखा का आनंद ले रहे हैं।",
      demoLabel: "प्रदर्शन हेतु नमूना / डेमो समीक्षाएँ — ये वास्तविक ग्राहक प्रशंसापत्र नहीं हैं।",
    },
    refund: {
      title: "रिटर्न और रिफंड नीति",
      intro: "भुगतान करने से पहले कृपया हमारी रिफंड नीति ध्यान से पढ़ें।",
      body: "भुगतान पूरा होने के बाद सभी भुगतान गैर-वापसी योग्य हैं। रिफंड केवल तभी संभव है जब हमारी वेबसाइट की किसी तकनीकी समस्या के कारण हस्तरेखा रिपोर्ट नहीं बन पाई हो — इसकी समीक्षा हमारी टीम करेगी।",
      note: "स्वीकृत रिफंड मूल भुगतान माध्यम से ही प्रोसेस किए जाते हैं। AstroFriend पर भुगतान पूरा करके आप इस रिटर्न और रिफंड नीति को स्वीकार करते हैं। रिपोर्ट डिजिटल हैं और आमतौर पर भुगतान के तुरंत बाद मिल जाती हैं।",
    },
    common: { loading: "लोड हो रहा है…", back: "वापस", tryAgain: "पुनः प्रयास करें" },
    library: {
      title: "ज्योतिष और हस्तरेखा प्रश्नोत्तर संग्रह",
      subtitle: "अपने ज्योतिष और हस्तरेखा से जुड़े प्रश्नों के आसान, त्वरित उत्तर पाएँ।",
      searchPlaceholder: "अपना प्रश्न खोजें...",
      categoriesTitle: "श्रेणी अनुसार देखें",
      allQuestions: "सभी प्रश्न",
      noResults: "कोई प्रश्न नहीं मिला। कोई और कीवर्ड आज़माएँ।",
      clearCategory: "हटाएँ",
      questions: "प्रश्न",
      filters: {
        all: "सभी", astrology: "ज्योतिष", kundli: "कुंडली", palmistry: "हस्तरेखा",
        career: "करियर", marriage: "विवाह", business: "व्यापार", finance: "धन",
        education: "शिक्षा", foreign: "विदेश यात्रा", family: "परिवार",
        property: "संपत्ति", forecast: "राशिफल",
      },
    },
    detail: {
      back: "संग्रह पर वापस",
      shortAnswer: "संक्षिप्त उत्तर",
      detailed: "विस्तृत व्याख्या",
      traditional: "पारंपरिक व्याख्या",
      relatedTopics: "संबंधित विषय",
      keywords: "कीवर्ड",
      relatedQuestions: "संबंधित प्रश्न",
      askKundli: "मेरी कुंडली AI से पूछें",
      askPalmistry: "AI हस्तरेखा से पूछें",
      disclaimer: "ज्योतिष और हस्तरेखा की व्याख्याएँ पारंपरिक या सांस्कृतिक मार्गदर्शन एवं मनोरंजन हेतु हैं — ये सुनिश्चित भविष्यवाणियाँ नहीं हैं।",
      healthDisclaimer: "किसी भी स्वास्थ्य समस्या के लिए कृपया योग्य चिकित्सक से परामर्श करें। यह उत्तर चिकित्सा सलाह नहीं है।",
    },
    ask: {
      kundliTitle: "मेरी कुंडली AI से पूछें",
      kundliDesc: "इस प्रश्न पर अपनी कुंडली अनुसार व्यक्तिगत ज्योतिषीय दृष्टिकोण पाएँ।",
      palmistryTitle: "AI हस्तरेखा से पूछें",
      palmistryDesc: "इस प्रश्न की पारंपरिक व्याख्या हेतु अपनी हथेली की फोटो अपलोड करें।",
      name: "आपका नाम (वैकल्पिक)",
      dob: "जन्म तिथि",
      tob: "जन्म समय (वैकल्पिक)",
      place: "जन्म स्थान",
      yourQuestion: "आपका प्रश्न",
      generate: "उत्तर पाएँ",
      generating: "सितारों से परामर्श…",
      readingPalm: "आपकी हथेली पढ़ रहे हैं…",
      choosePhoto: "हथेली की फोटो चुनें",
      changePhoto: "फोटो बदलें",
      answerTitle: "AstroFriend कहता है",
      loginRequired: "AI सुविधाओं हेतु कृपया लॉगिन करें।",
      askAgain: "फिर से पूछें",
      close: "बंद करें",
      disclaimer: "केवल मार्गदर्शन हेतु पारंपरिक व्याख्या — सुनिश्चित भविष्यवाणी नहीं।",
    },
  },
};
